"use client";

import { useFilterStore } from "@faire/deprecated-retailer-visitor-shared/components/Filters/useFilterStore";
import { useSearchPageFiltersDataContext } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/SearchPageFiltersDataContext";
import { useSearchPageIsFromDiscoverURL } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { IGetProductFilterSectionInfoResponse } from "@faire/web-api--source/indigofair/data/IGetProductFilterSectionInfoResponse";
import { IQueryProductsV2WithLeanTileResponse } from "@faire/web-api--source/indigofair/data/IQueryProductsV2WithLeanTileResponse";
import cloneDeep from "lodash/cloneDeep";
import React, { use, useEffect, useMemo } from "react";

export const SearchPageFiltersSetter = () => {
  const { setFilterState } = useFilterStore([]);
  const {
    filtersResponse: filtersResponsePromise,
    legacyFiltersResponse,
    loading,
  } = useSearchPageFiltersDataContext();
  const filtersResponse =
    (filtersResponsePromise && use(filtersResponsePromise)) ||
    legacyFiltersResponse;
  const isFromDiscoverURL = useSearchPageIsFromDiscoverURL();

  const filterSections = filtersResponse?.filter_sections;
  const filterPills = (filtersResponse as IGetProductFilterSectionInfoResponse)
    ?.filter_pills;

  const formattedTotalPrimaryResultsCount = useMemo(() => {
    if (isFromDiscoverURL) {
      return (
        (filtersResponse as IQueryProductsV2WithLeanTileResponse)
          ?.formatted_total_primary_results_count ?? ""
      );
    }
    return (
      (filtersResponse as IGetProductFilterSectionInfoResponse)
        ?.formatted_total_products_count ?? ""
    );
  }, [filtersResponse, isFromDiscoverURL]);

  const totalPrimaryResultsCount = useMemo(() => {
    if (isFromDiscoverURL) {
      return (
        (filtersResponse as IQueryProductsV2WithLeanTileResponse)
          ?.total_primary_results ?? 0
      );
    }
    return (
      (filtersResponse as IGetProductFilterSectionInfoResponse)
        ?.total_products_count ?? 0
    );
  }, [filtersResponse, isFromDiscoverURL]);

  useEffect(() => {
    if (filterSections && !loading) {
      setFilterState((currentState) => ({
        ...currentState,
        filterSections: cloneDeep(filterSections),
        filterPills: cloneDeep(filterPills),
        isNewFilterSelected: false,
        totalPrimaryResultsCount: totalPrimaryResultsCount,
        totalPrimaryResultsCountFormatted: formattedTotalPrimaryResultsCount,
      }));
    }
  }, [
    filterSections,
    filterPills,
    setFilterState,
    loading,
    totalPrimaryResultsCount,
    formattedTotalPrimaryResultsCount,
  ]);

  return <></>;
};
